import fr_FR from "antd/lib/locale/fr_FR";
import en_GB from "antd/lib/locale/en_GB";
import i18n from "config/i18n/i18n";
const CONFIG_TRANSLATIONS = {
  fr: fr_FR,
  en: en_GB,
};
export const locale = CONFIG_TRANSLATIONS[i18n.language as keyof typeof CONFIG_TRANSLATIONS];
